import React, { useState, useEffect } from "react";
import "./AddAsset.css";
import apiClient from "../utils/apiClient"; // adjust path if needed
import SessionHandler from "../components/SessionHandler";


const AddAsset = () => {
  const [employees, setEmployees] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [inventoryAssets, setInventoryAssets] = useState([]);

  const [formData, setFormData] = useState({
    employeeId: "",
    name: "",
    email: "",
    department: "",
    designation: "",
    location: "",
    assetName: "",
    assetNumber: "",
    brand: "",
    model: "",
    serialNumber: "",
    assignedDate: "",
    status: "Active",
    remarks: "",
  });

 useEffect(() => {
  const fetchEmployees = async () => {
    try {
      const data = await apiClient(
        "/auth/allemployees/"
      );

      const employeeList = Array.isArray(data)
        ? data
        : data?.results || data?.employees || [];

      setEmployees(employeeList);

        console.log("Employees Loaded:", employeeList);

        if (employeeList.length > 0) {
        console.log("First Employee:", employeeList[0]);
        }
    } catch (error) {
      console.error("Employee Fetch Error:", error);
      setEmployees([]);
    }
  };

  fetchEmployees();
}, []);

useEffect(() => {
  const fetchInventory = async () => {
    try {
      const data = await apiClient(
        "/assetinventory/inventory/list/"
      );

      const list = Array.isArray(data)
        ? data
        : data.results || [];

      setInventoryAssets(list);

      console.log("Inventory:", list);

    } catch (err) {
      console.error(err);
    }
  };

  fetchInventory();
}, []);

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "assetName") {
    setFormData(prev => ({
      ...prev,
      assetName: value,
      assetNumber: "",
      brand: "",
      model: "",
      serialNumber: "",
    }));
    return;
  }

  setFormData(prev => ({
    ...prev,
    [name]: value,
  }));
};

const handleEmployeeSearch = (e) => {
  const value = e.target.value;

  setFormData((prev) => ({
    ...prev,
    employeeId: value,
  }));

  if (!value.trim()) {
    setSuggestions([]);
    return;
  }

  const filtered = employees.filter((emp) => {
    const empId = emp.employee_id || "";
    const empName = emp.name || "";

    return (
      empId.toLowerCase().includes(value.toLowerCase()) ||
      empName.toLowerCase().includes(value.toLowerCase())
    );
  });

  setSuggestions(filtered);
};

const handleEmployeeSelect = (emp) => {
  setFormData((prev) => ({
    ...prev,
    employeeId: emp.employee_id || "",
    name: emp.name || "",
    email: emp.email || "",
    department: emp.department || "",
    designation:
      emp.designation ||
      emp.position ||
      emp.role_type ||
      "",
    location:
      emp.location ||
      emp.address ||
      "",
  }));

  setSuggestions([]);
};

const handleAssetSelect = (e) => {
  const assetNumber = e.target.value;

  const asset = inventoryAssets.find(
    (a) => a.asset_number === assetNumber
  );

  if (!asset) return;

  setFormData((prev) => ({
    ...prev,

    assetNumber: asset.asset_number,
    assetName: asset.asset_name,

    brand: asset.brand,
    model: asset.model,
    serialNumber: asset.serial_number,

    location: asset.location,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.employeeId) {
    setMessage("Please select an employee.");
    return;
  }

  if (!formData.assetNumber) {
    setMessage("Please enter Asset Number.");
    return;
  }

  if (!formData.brand) {
    setMessage("Please select Brand.");
    return;
  }

  if (!formData.assignedDate) {
    setMessage("Please select Assigned Date.");
    return;
  }

  setLoading(true);
  setMessage("");

  try {
      const data = await apiClient("/assets/add/", {
      method: "POST",
      body: JSON.stringify({
          employee_id: formData.employeeId,
          employee_name: formData.name,
          email: formData.email,
          department: formData.department,
          designation: formData.designation,
          asset_name: formData.assetName,
          asset_number: formData.assetNumber,
          brand: formData.brand,
          model: formData.model,
          serial_number: formData.serialNumber,
          assigned_date: formData.assignedDate,
          status: formData.status,
          remarks: formData.remarks,
      }),
  });

    if (!data) return;

    setShowDialog(true);

    setFormData({
      employeeId: "",
      name: "",
      email: "",
      department: "",
      designation: "",
      location: "",
      assetName: "",
      assetNumber: "",
      brand: "",
      model: "",
      serialNumber: "",
      assignedDate: "",
      status: "Active",
      remarks: "",
    });

    setSuggestions([]);
  } catch (error) {
    console.error(error);
    setMessage(
      error?.message || "Failed to create asset assignment."
    );
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="asset-modal">
      <div className="asset-header">
        <h2>New Laptop Assignment</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="asset-grid">
          <div className="form-group">
            <label>EMPLOYEE ID *</label>

            <div className="autocomplete-wrapper">
              <input
                type="text"
                placeholder="Search Employee ID"
                value={formData.employeeId}
                onChange={handleEmployeeSearch}
              />

              {suggestions.length > 0 && (
                <ul className="suggestion-list">
                  {suggestions.map((emp) => (
                <li
                    key={emp.id}
                    onClick={() => handleEmployeeSelect(emp)}
                >
                    {emp.employee_id} - {emp.name}
                </li>
                ))}
                </ul>
              )}
            </div>
          </div>

          <div className="form-group">
            <label>NAME *</label>
            <input
              type="text"
              value={formData.name}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>EMAIL</label>
            <input
              type="email"
              value={formData.email}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>DEPARTMENT</label>
            <input
              type="text"
              value={formData.department}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>DESIGNATION</label>
            <input
              type="text"
              value={formData.designation}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>LOCATION</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
            />
          </div>
        </div>

        <h3 className="section-title">ASSET DETAILS</h3>

<div className="asset-grid">

  <div className="form-group">
    <label>ASSET NAME *</label>

    <select
      name="assetName"
      value={formData.assetName}
      onChange={handleChange}
    >
      <option value="">Select Asset Name</option>

      {[...new Set(inventoryAssets.map(a => a.asset_name))]
        .map(name => (
          <option key={name} value={name}>
            {name}
          </option>
      ))}
    </select>

  </div>

  <div className="form-group">
    <label>ASSET NUMBER *</label>

    <select
      value={formData.assetNumber}
      onChange={handleAssetSelect}
    >
      <option value="">Select Asset Number</option>

      {inventoryAssets
        .filter(
          asset =>
            asset.asset_name === formData.assetName &&
            asset.asset_status === "Available"
        )
        .map(asset => (
          <option
            key={asset.id}
            value={asset.asset_number}
          >
            {asset.asset_number}
          </option>
      ))}
    </select>

  </div>

  <div className="form-group">
    <label>BRAND</label>
    <input value={formData.brand} readOnly />
  </div>

  <div className="form-group">
    <label>MODEL</label>
    <input value={formData.model} readOnly />
  </div>

  <div className="form-group">
    <label>SERIAL NUMBER</label>
    <input value={formData.serialNumber} readOnly />
  </div>

</div>
        <h3 className="section-title">ASSIGNMENT</h3>

        <div className="asset-grid">
          <div className="form-group">
            <label>ASSIGNED DATE *</label>
            <input
              type="date"
              name="assignedDate"
              value={formData.assignedDate}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>STATUS</label>
            <input
              type="text"
              value="Active"
              readOnly
            />
          </div>
        </div>

        <div className="form-group full-width">
          <label>REMARKS</label>
          <textarea
            rows="4"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            placeholder="Enter remarks"
          />
        </div>

     <div className="button-row">
  <button
    type="button"
    className="cancel12-btn"
    onClick={() =>
      setFormData({
        employeeId: "",
        name: "",
        email: "",
        department: "",
        designation: "",
        location: "",
        assetNumber: "",
        brand: "",
        model: "",
        serialNumber: "",
        assignedDate: "",
        status: "Active",
        remarks: "",
      })
    }
  >
    Cancel
  </button>

  <button
    type="submit"
    className="save-btn"
    disabled={loading}
  >
    {loading ? "Creating..." : "Create"}
  </button>
</div>
</form>

{showDialog && (
  <div className="dialog-overlay">
    <div className="dialog-box">
      <p>✅ Asset Assigned Successfully.</p>
      <button onClick={() => setShowDialog(false)}>
        OK
      </button>
    </div>
  </div>
)}

{message && (
  <div className="message">
    {message}
  </div>
)}

<SessionHandler />
  </div> 
  );
};

export default AddAsset;